import { render, staticRenderFns } from "./safetyGearRequest.vue?vue&type=template&id=ef7810d6"
import script from "./safetyGearRequest.vue?vue&type=script&lang=js"
export * from "./safetyGearRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef7810d6')) {
      api.createRecord('ef7810d6', component.options)
    } else {
      api.reload('ef7810d6', component.options)
    }
    module.hot.accept("./safetyGearRequest.vue?vue&type=template&id=ef7810d6", function () {
      api.rerender('ef7810d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/sas/safetyGearRequest.vue"
export default component.exports